import React, {useMemo} from 'react'
import PropTypes from 'prop-types';
import {wasEverPublished} from "libs/getDemandStatus";
import {connect} from "react-redux";
import Confirm from "components/popup/confirm/Confirm";

function ConfirmPublish(
    {
        open,
        onConfirm,
        onCancel,
        demandHeader
    }) {

    const confirmText = useMemo(() => {
        let wasPublished = wasEverPublished() === true;
        let noticeOjsType = !!demandHeader?.noticeOjsType;
        return wasPublished ? (noticeOjsType ? 'publish_modification_ojs_popup_text' : 'publish_modification_popup_text') : 'publish_popup_text';
    }, [demandHeader]);


    return (
        <Confirm
            open={open}
            onConfirm={onConfirm}
            onCancel={onCancel}
            confirmText={confirmText}
        />
    )
}

ConfirmPublish.propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(ConfirmPublish);
